/**
 * Created by lk on 17/6/4.
 */
import axios from "../../utils/axios";
 import qs from 'qs'
// 列表
export function getList(query) {
    return axios({
        url: "mbUser/getList",
        method: "get",
        params: query
    });
}
// 用户管理 - 获取用户列表 - 企业信息
export function getListByUserId(query) {
    return axios({
        url: "mbUser/getListByUserId",
        method: "get",
        headers:{'content-type': "application/x-www-form-urlencoded"},
        params: query
    });
}
export function getSuperNameBySuperId(query) {
    return axios({
        url: "mbUser/getSuperNameBySuperId",
        method: "get",
        params: query
    });
}
// 保存
export function saveMbUser(data, formName) {
    console.info("front data=",data);
    var url = formName === "add" ? "/mbUser/add" : "/mbUser/edit";
   // data=qs.stringify(data)
    console.info("behind data=",data);

    return axios({
        url: url,
        method: "post",
        headers:{'content-type': "application/x-www-form-urlencoded"},
        params: data
    });
}
// 校验是否重复账号
export function relogin(data) {
    return axios({
        url: "/mbUser/relogin",
        method: "post",
        data: data
    });
}
// 删除
export function userdelete(data) {
    return axios({
        url: "/mbUser/userdelete",
        headers:{'content-type': "application/x-www-form-urlencoded"},
        method: "post",
        data: data
    });
}
//删除积分
export function deleteUserIntegral(data) {
    return axios({
        url: "/mbUser/deleteUserIntegral",
        method: "post",
        headers:{'content-type': "application/x-www-form-urlencoded"},
        data: data
    });
}
export function editGrade(data) {
    return axios({
        url: "/mbUser/editGrade",
        method: "post",
        headers:{'content-type': "application/x-www-form-urlencoded"},
        params:data
        // data: data
    });
}
//获取青牛token
export function getToken() {
    return axios({
        url: "/qiniu/getToken",
        method: "get"
    });
}
export function addUserGroup(data) {
    return axios({
        url: "usergroup/addUserGroup",
        method: "post",
        data: data
    });
}
//获取所有客服
export function getListAll(query) {
    return axios({
        url: "mbUser/getMbUserSer",
        method: "get",
        params: query
    });
}
//获取所有等级
export function getAllGrade(query) {
    return axios({
        url: "mbUser/getAllGrade",
        method: "get",
        params: query
    });
}
/**禁止用户登录 */
export function editUserBan(data) {
    return axios({
        url: "mbUser/editUserBan",
        method: "post",
        data: data
    });
}
/**禁止用户登录 */
export function getMbIntegral(query) {
    return axios({
        url: "mbUser/getMbIntegral",
        method: "get",
        params: query
    });
}
/**
 * 单独获取积分获得/消耗方式
 */
export function getIntegralNote(query) {
    return axios({
        url: "mbUser/getIntegralNote",
        method: "get",
        params: query
    });
}
/**发放积分 */
export function addIntegral(data) {
    console.log("aaaaaaaaaaaaaaaaaaaaaaaaaaaa",data);
    return axios({
        url: "mbUser/addIntegral",
        method: "post",
        headers:{'content-type': "application/x-www-form-urlencoded"},
        params:data
        // data: data
    });
}
export function getUserAddress(query) {
    return axios({
        url: "userAddress/getUserAddress",
        method: "get",
        params: query
    });
}
// 获取国家下拉框
export function getCountry(query) {
    return axios({
        url: "mbUser/getCountry",
        method: "get",
        data: query
    });
}
// 用户管理 - 查询所有销售 /mbUser/getSale
export function getSale(query) {
    return axios({
        url: "mbUser/getSale",
        method: "get",
        data: query
    });
}
// 修改销售 /mbUser/editSale
export function editSale(data) {
    return axios({
        url: "mbUser/editSale",
        method: "post",
        data: data
    });
}
// 导入 /mbUser/userExcel
export function userExcel(data) {
    return axios({
        url: "mbUser/userExcel",
        method: "post",
        data: data
    });
}
// 共享用户数据到三方销客系统上
export function insertUser() {
  return axios({
      url: "/mbUser/insertCustomer",
      method: "post"
  });
}
// 同步三方销客系统用户数据到本系统上
export function getUser() {
  return axios({
      url: "/mbUser/getUserEnterprise",
      method: "post"
  });
}


//  有企业修改，没有企业新增
export function updEnterprise(data) {
    return axios({
        url: "mbUser/updEnterprise",
        method: "post",
        data: data
    });
}
